import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone'
})
export class PhoneNumberPipe implements PipeTransform {
    transform(value: string, ...args: unknown[]) {
        if (value) {
            const cleaned = value.replace(/\D/g, '');
            return '(' + cleaned.slice(0, 3) + ') ' + cleaned.slice(3, 6) + '-' + cleaned.slice(6);
        }

        return value;
    }
}
